export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN
export const CACHE_BUSTER = import.meta.env.VITE_CACHE_BUSTER
export const LASTMOD = import.meta.env.VITE_LASTMOD
export const NO_INDEX = import.meta.env.VITE_NO_INDEX
export const AUBA_STARTUP_URL = import.meta.env.VITE_AUBA_STARTUP_URL
export const CDN_URL = import.meta.env.VITE_CDN_URL
